import { useState } from "react";

import api from "shared/infra/services/api";
import { dispatchErrorRoutine } from "shared/utils/dispatchErrorRoutine";

import { useNewGlobalSearch } from "../useNewGlobalSearch";

export const useNewGlobalSearchService = () => {
  const { setAuthorsList, setTagsList } = useNewGlobalSearch();
  const [isLoading, setIsLoading] = useState({
    GETTING_AUTHORS: false,
    GETTING_TAGS: false,
  });

  const getAuthors = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, GETTING_AUTHORS: true }));
      const response = await api.get(`/group-lessons/authors/all`);
      setAuthorsList(response.data.data);
    } catch (error) {
      dispatchErrorRoutine({
        error,
        errorMessage: "Error ~ useNewGlobalSearchService::getAuthors",
        errorMessageToClient:
          "Não foi possivel buscar pelos autores, tente novamente mais tarde.",
      });
    } finally {
      setIsLoading((prev) => ({ ...prev, GETTING_AUTHORS: false }));
    }
  };

  const getTags = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, GETTING_TAGS: true }));
      const response = await api.get(`/group-tag-categories?attached=1`);
      setTagsList(response.data.data);
    } catch (error) {
      dispatchErrorRoutine({
        error,
        errorMessage: "Error ~ useNewGlobalSearchService::getTags",
        errorMessageToClient:
          "Não foi possivel buscar pelas tags, tente novamente mais tarde.",
      });
    } finally {
      setIsLoading((prev) => ({ ...prev, GETTING_TAGS: false }));
    }
  };

  return { getAuthors, getTags, isLoading };
};
